<!-- 商户后台管理-核销管理 -->
<template>
    <div class="main-container">
        <div class="filter-container">
            <el-select-v2
                v-if="hasShop"
                class="filter-item"
                filterable
                v-model="filters.shop_user_id"
                placeholder="商户列表"
                clearable
                :props="{value: 'id',label: 'shop_description'}"
                :options="shopUserList"
            />
            <SelectBrand :ifBody="1" @brandChange="onBrandChange"/>
            <el-input class="filter-item" v-model="filters.search_value" style="width:170px" placeholder="券码" clearable></el-input>
            <el-input class="filter-item" v-model="filters.coupon_name" style="width:170px" placeholder="券名称" clearable></el-input>
            <el-date-picker class="filter-item" v-model="filters.start_date" style="width:170px" placeholder="开始日期" value-format="YYYY-MM-DD"></el-date-picker>
            <span class="filter-item filter-divider">-</span>
            <el-date-picker class="filter-item" v-model="filters.end_date" style="width:170px" placeholder="结束日期" value-format="YYYY-MM-DD"></el-date-picker>
            <el-button class="filter-btn" type="primary" @click="search()">搜索</el-button>
            <el-button class="filter-btn" type="primary" @click="output()">批量导出</el-button>
            <el-button v-if="store.state.user.userInfo.id != 6079" class="filter-btn" type="primary" @click="chargeOff()">电子券核销</el-button>
        </div>

        <!-- 数据总览 -->
        <el-row :gutter="10" class="mb20">
            <el-col :span="5">核销张数：<span style="color:#E6A23C">{{ checkPiece }}</span></el-col>
            <el-col :span="5">核销金额：<span style="color:#E6A23C">{{ checkAmount }}</span></el-col>
            <el-col :span="5">平均折扣：<span style="color:#E6A23C">{{ average_discount }}</span></el-col>
            <el-col :span="5">结算金额：<span style="color:#E6A23C">{{ clearing_price }}</span></el-col>
        </el-row>
        <!-- 数据统计 -->
        <el-collapse>
            <el-collapse-item title="数据统计">
                <el-table :data="countData" style="width:100%">
                    <el-table-column prop="coupon_name" label="名称"></el-table-column>
                    <el-table-column prop="count" label="核销张数"></el-table-column>
                    <el-table-column prop="amount_all" label="核销金额"></el-table-column>
                    <el-table-column prop="average_discount" label="平均折扣"></el-table-column>
                    <el-table-column prop="clearing_price" label="结算金额"></el-table-column>
                </el-table>
            </el-collapse-item>
        </el-collapse>
        <el-table :data="tableData" border show-summary :summary-method="getSummaries" style="width:100%">
            <el-table-column type="index" :index="tableIndex" width="70"></el-table-column>
            <el-table-column prop="brand_id" label="品牌ID"></el-table-column>
            <el-table-column prop="shop_name" label="门店"></el-table-column>
            <el-table-column prop="coupon_name" label="名称"></el-table-column>
            <el-table-column prop="coupon_no" label="券码"></el-table-column>
            <el-table-column prop="amount" label="金额"></el-table-column>
            <el-table-column prop="created_at" label="核销时间" width="160"></el-table-column>
            <el-table-column prop="valid_from" label="有效期" width="200">
                <template #default="scope">
                    {{scope.row.valid_from}}至{{scope.row.valid_to}}
                </template>
            </el-table-column>
        </el-table>
        <Pagination :currentPage="filters.page" :total="count" @pageChange="onPageChange" @sizeChange="onSizeChange" />

        <el-dialog title="电子券核销" v-model="dialogDeliveryFormVisible" :before-close="clearResultMsg" :close-on-click-modal="false">
            <el-form ref="chargeOffForm" inline>
                <el-form-item prop="check_coupon">
                    <el-input v-model.trim="check_coupon" autocomplete="off" placeholder="请输入券码" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="submitForm()">提交</el-button>
                </el-form-item>
                <div v-if="resultMsg" class="error-msg">{{ '* ' + resultMsg }}</div>
            </el-form>
            <el-table :data="chargeOffData" border>
                <el-table-column prop="name" label="名称"></el-table-column>
                <el-table-column prop="coupon_no" label="券码"></el-table-column>
                <el-table-column prop="amount" label="金额"></el-table-column>
                <el-table-column label="有效期" width="200">
                    <template #default="scope">
                        {{scope.row.valid_from}}至{{scope.row.valid_to}}
                    </template>
                </el-table-column>
                <el-table-column label="状态">
                    <template #default="scope">
                        {{scope.row.status ? '已核销' : '未核销'}}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="75">
                    <template #default="scope">
                        <div class="action-list">
                            <el-button :disabled="scope.row.status != 0" size="small" type="primary" @click.prevent="couponVerifications(scope.$index)">核销</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <template #footer>
                <span class="dialog-footer">
                    <!-- <el-button @click="dialogDeliveryFormVisible = false">取 消</el-button> -->
                    <!-- <el-button type="primary" @click="dialogDeliveryFormVisible = false">关闭</el-button> -->
                </span>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import {useRouter,useRoute} from 'vue-router'
import { defineComponent, getCurrentInstance, toRefs, reactive } from 'vue'
import { useStore } from '@/store/index'
import { joinParams } from '@/utils/index'
import Keys from '@/constant/key'
import Pagination from '@/components/Pagination'
import SelectBrand from '@/components/SelectBrand.vue'
export default defineComponent({
name: 'VoucherList',
components: { Pagination,SelectBrand },
setup() {
    const { proxy } = getCurrentInstance()
    const router = useRouter()
    const store = useStore()
    const hasShop = store.state.user.userInfo.hasShop
    const groupIdArr = store.state.user.userInfo.group_id.split(',') // 当前用户拥有角色权限ID
    const state = reactive({
        filters: {
            search_value:   '', // 券码
            coupon_name:    '', // 券名称
            shop_user_id:   '', // 商户ID
            brand_id:       '', // 品牌ID
            start_date:     '', // 开始日期
            end_date:       '', // 结束日期
            limit:          10, // 每页条数
            page:           1   // 页码
        },
        brandList:          [], // 当前用户关联品牌（非商户类获取全部）
        checkPiece:         0,  // 核销张数
        checkAmount:        0,  // 核销总金额
        checkAmountPage:    0,  // 当前页核销总金额
        average_discount:   0,  // 平均折扣
        clearing_price:     0,  // 结算金额
        check_coupon:'',
        tableData: [],
        countData:  [],         //数据统计
        shopUserList:[],
        is_show: groupIdArr.includes('1') || groupIdArr.includes('7'), // 是否为有超级管理员或总商户权限
        chargeOffData:[],
        count: 0,
        dialogDeliveryFormVisible: false,
        resultMsg:   '', // 券码不存在、已核销、已过期等异常提示文案

        onSizeChange(val){
            state.filters.limit = val
            state.getList();
        },
        onPageChange(val) {
            state.filters.page = val
            state.getList();
        },
        getList(){
            proxy.$http.get(`/admin/merchant/getChargeOffList?${joinParams({...state.filters})}`).then(res => {
                const { code, data, msg, count } = res
                if (code != 0) { proxy.$message({ type: 'error', message: msg }) }
                const { amount, amount_all, count:checkPiece,average_discount,clearing_price,info,coupon_info} = data
                state.tableData = info
                state.countData = coupon_info
                state.checkPiece = checkPiece
                state.checkAmount = amount_all
                state.checkAmountPage = amount
                state.average_discount = average_discount
                state.clearing_price = clearing_price
                state.count = count
            })
        },
        onBrandChange (val) {
            state.filters.brand_id = val
        },
        search(){
            state.filters.page = 1
            state.getList();
        },
        output(){
            window.open(`${Keys.baseUrl}/admin/merchant/getChargeOffList?${joinParams({...state.filters})}&export=1&user_id=${store.state.user.userInfo.id}`);
        },
        submitForm(){
            const { check_coupon, chargeOffData } = state
            state.resultMsg = '' // 清空上一次的结果
            if (!check_coupon) {
                return proxy.$message({ type: 'error', message: '请输入券码' })
            }
            proxy.$http.get(`/admin/merchant/code_coupon_no?coupon_no=${check_coupon}`).then(res => {
                const { code, data, msg } = res
                if (code==200 || msg==='券码已核销') {
                    const { id } = data
                    if (chargeOffData.filter(item => item.id === id).length === 0) {
                        state.chargeOffData.push(res.data)
                    }
                    if (msg === '券码已核销') {
                        state.resultMsg = res.msg
                    }
                } else {
                    state.resultMsg = res.msg
                }
            })
        },
        getShopList:()=>{
            proxy.$http.get(`/admin/shop_product/getShopList?user_id=${store.state.user.userInfo.id}&cat_type='2,3'`).then(res => {
                if(res.code == 200){
                    state.shopUserList = res.data;
                }else{
                    state.shopUserList = [];
                }
            })
        },
        // 获取当前用户关联品牌列表
        getBrandList:()=>{
            proxy.$http.post('/admin/shop_product/getBrandList?id_show=1').then((res) => {
                state.brandList = res.data
            })
        },
        chargeOff(){
            state.check_coupon = '';
            state.chargeOffData = [];
            state.dialogDeliveryFormVisible = true;
        },
        couponVerifications(index){
            const { chargeOffData } = state
            const { coupon_no } = chargeOffData[index]
            proxy.$http.get(`/admin/merchant/verification?coupon_no=${coupon_no}`).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                proxy.$message({ type: 'success', message: res.msg })
                chargeOffData[index].status = 1
                state.getList()
            })
        },
        // 清除上一次核销结果提示信息
        clearResultMsg: () => {
            state.resultMsg = ''
            state.dialogDeliveryFormVisible = false
        },
        // 表格 index 连续
        tableIndex: (index) => {
            const { page, limit } = state.filters
            return (page - 1) * limit + index + 1
        },
        // 计算总计
        getSummaries: (param) => {
            const { columns, data } = param
            const sums = []
            columns.forEach((column, index) => {
                if (index === 0) {
                    sums[index] = '总计行'
                    return
                }
                if (index === 5) {
                    const values = data.map((item) => Number(item[column.property]))
                    if (!values.every((value) => Number.isNaN(value))) {
                        let sum = values.reduce((prev, curr) => {
                            const value = Number(curr)
                            if (!Number.isNaN(value)) {
                                return prev + curr
                            } else {
                                return prev
                            }
                        }, 0)
                        sums[index] = sum.toFixed(2)
                    } else {
                        sums[index] = 'N/A'
                    }
                }
            })

            return sums
        }
    })

    hasShop && state.getShopList()
    state.getBrandList()
    if (store.state.user.userInfo.user_type == 2) {
        state.getList()
    }
    return { ...toRefs(state), hasShop, Keys, store }
}
})
</script>

<style lang="stylus" scoped>
    .error-msg
        margin -13px 0 20px
        padding-left 10px
        color #f56c6c
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
</style>